import axios from 'axios';
import config from '../../config';


const baseUrl = config.baseUrl + '/api/perfiles';

const getInformacionG = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/informacion-general`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const getImagenes = async (municipio) => {
    try {
        const response = await axios.get(`${baseUrl}/getimagenes`, {
            params: { municipio } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const getmunicipios = async (areaId) => {
    try {
        const response = await axios.get(`${baseUrl}/municipios`);
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo los temas del área', error);
        throw error;
    }
};

const getdatoIndicador = async (municipio, vistaNombre) => {
    try {
        const response = await axios.post(`${baseUrl}/datoIndicador`, {
            params: { municipio: municipio, vista: vistaNombre } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error insertando el indicador', error);
        throw error;
    }
};
const getMunicipios = async () => {
    try {
      const response = await axios.get(`${baseUrl}/municipios`); // Reemplaza con la URL de tu API
      return response;
    } catch (error) {
      console.error('Error fetching municipios:', error);
      throw error;
    }
}
export {
    getInformacionG,
    getmunicipios,
    getdatoIndicador,
    getImagenes,
    getMunicipios,
};